<wr-base-dialog header="Textbaustein einfügen"
                cancelText="Abbrechen"
                [showSubmitButton]="false">
  <div class="text-block-list">
    @for (textBlock of textBlocks; track textBlock.id) {
      <button type="button" class="text-block-option" data-cy="text-block-option" (click)="select(textBlock)">
        <span class="text-block-text">{{ textBlock.text }}</span>
        <nb-icon pack="eva" icon="plus-circle-outline" status="primary"></nb-icon>
      </button>
    }
  </div>
</wr-base-dialog>
